<template>
    <div class="relative">
        <div class="absolute -mt-1 md:-mt-10 pl-1 md:pl-3">
            <i class="text-sm text-green-warm-500 fas fa-plus"></i>
        </div>

        <form-row title="Sale Bonus"
            :no_border="true"
            class="mt-6 md:-mt-2 mb-6"
            label_class="ml-8 md:ml-0"
        >
            <input-money
                class="sm:w-36"
                name="purchase_side_sale_bonus"
                :value="value"
                @input="$emit('input', $event)"
                :read_only="read_only"
            />
        </form-row>

        <div class="border-b border-gray-400 md:ml-46 mb-6"></div>
    </div>
</template>

<script>
export default {
    props: {
        value: { default: null },
        read_only: { default: false },
    },
}
</script>
